import React from "react";

interface IconProps {
  fill?: string;
  height?: string;
}

const Cleaning: React.FC<IconProps> = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 96 96.25"
    fill={props.fill || "#0071B9"}
    height={props.height || "16px"}
  >
    <title>Cleaning</title>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Cleaning">
          <path d="M94.926,50.39c0-14.955-12.14-27.122-27.062-27.122c-14.921,0-27.061,12.167-27.061,27.122v6.534h3.212l3.391,34.04&#10;&#9;c0.192,2.994,2.652,5.317,5.67,5.317h29.577c3.018,0,5.479-2.323,5.67-5.318l3.398-34.039h3.205V50.39z M80.551,88.281H55.179&#10;&#9;l-3.317-33.229h32.007L80.551,88.281z M86.283,47.053H49.446c-0.846,0-1.677,0.194-2.437,0.545&#10;&#9;c1.369-10.328,10.187-18.33,20.855-18.33s19.486,8.001,20.856,18.33C87.96,47.247,87.13,47.053,86.283,47.053z M22.952,72.794&#10;&#9;h14.952v8H0v-8h14.952V5c0.003-2.208,1.792-3.997,4-3.997c2.208,0,4.004,1.79,4.004,3.999v0.24&#10;&#9;C22.952,5.242,22.952,72.794,22.952,72.794z M14.952,85.15h8V96h-8V85.15z M0.316,85.15h8V96h-8V85.15z M29.588,85.15h8V96h-8V85.15&#10;&#9;z" />
        </g>
      </g>
    </g>
  </svg>
);

export default Cleaning;
